import { useCallback } from 'react';

import { useSegmentAnalyticsContext } from '@/SegmentAnalyticsProvider';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type AnyFunction = (...args: any[]) => any;

export function useSegmentEventWrapper(
  _event:
    | string
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    | ((...args: any[]) => string)
    | ((...args: any[]) => [string, any])
) {
  const context = useSegmentAnalyticsContext();

  return useCallback(
    <F extends AnyFunction>(
      callback: F
    ): ((...args: Parameters<F>) => ReturnType<F>) => {
      if (!context) return callback;
      const { analytics, data } = context;
      const wrappedCallback = (...args: Parameters<F>): ReturnType<F> => {
        const event = typeof _event === 'string' ? _event : _event(...args);
        if (typeof event === 'string') {
          analytics?.track(event, data);
        } else {
          analytics?.track(event[0], event[1]);
        }
        return callback(...args);
      };
      return wrappedCallback;
    },
    [context, _event]
  );
}

export function useSimpleSegementEvent() {
  const context = useSegmentAnalyticsContext();
  return useCallback(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (event: string, data: Record<string, any>) => {
      if (!context) return;
      const { analytics, data: _data } = context;
      analytics?.track(event, { ..._data, ...data });
    },
    [context]
  );
}
